import styled from "styled-components";

const Styles = styled.div`
  padding-left: 24px;
  h1 {
    margin-block-start: 0em;
    margin-block-end: 0em;
    font-weight: 700;
  }
  .col-input-container {
    margin-inline-end: 16px;
  }
`;

export default Styles;
